// Ticket 24: LoveCoins + Virtual Gifting API

const API_BASE = window.location.origin;

export async function fetchLovecoinsBalance() {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE}/api/wallet/lovecoins`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  });
  if (!res.ok) throw new Error('Failed to fetch LoveCoins balance');
  return res.json();
}

export async function fetchGiftCatalog() {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE}/api/gifts/catalog`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  });
  if (!res.ok) throw new Error('Failed to fetch gift catalog');
  return res.json();
}

export async function sendGift(body) {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE}/api/gifts/send`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
    },
    body: JSON.stringify(body),
  });
  
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    const error = new Error(errorData.detail?.message || errorData.detail || 'Failed to send gift');
    error.code = errorData.detail?.code;
    error.balance = errorData.detail?.balance;
    error.required = errorData.detail?.required;
    throw error;
  }
  
  return res.json();
}

// Ticket 26: Fetch gift history
export async function fetchReceivedGifts() {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE}/api/gifts/received`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  });
  if (!res.ok) throw new Error('Failed to fetch received gifts');
  return res.json();
}
